import React from 'react'

// material-ui
import Hidden from '@mui/material/Hidden'

// components
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'
import { useBrand } from 'components/shared/SettingsProvider'

const Header = props => {
  const { marcomUrl } = useBrand()

  const headerProps = {
    title: 'Virtual Camp Schedule',
    learnMoreText: 'Learn More',
    learnMoreLink: `${marcomUrl}/bright-horizons/virtual-camp`,
    logInText: 'Log In',
    logInLink: '/'
  }

  return (
    <>
      <Hidden smUp>
        <MobileHeader {...headerProps} />
      </Hidden>
      <Hidden smDown>
        <DesktopHeader {...headerProps} />
      </Hidden>
    </>
  )
}

export default Header
